import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { OrderEntry } from '@spartacus/cart/base/root'

export class FilterOderEntriesWithProperty {

  static filterOrderEntries (source: Observable<OrderEntry[]>, property: any ): Observable<OrderEntry[]> {
    return source.pipe(
      map(orderEntries => orderEntries.filter((orderEntry: any) => orderEntry?.purchasable === property))
    )
  }
}
